<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0-beta3/css/all.min.css">
<div class="access-denied-container">
    <p style="color: red; text-align: center;">
        <i class="fas fa-ban"></i> access-denied.
    </p>
    <p style="color: red; text-align: center;">You do not have permission to view this application.</p>
</div>


